import React, { Component } from "react";
import { connect } from "react-redux";
import { getDataAction, editDataAction } from "../config/redux/action";
import { Icon, Input, Radio, Button } from "semantic-ui-react";
import { TableComp } from "../component/TableComp";
import { HeaderComp } from "./Activity/HeaderComp";
import { Modal, ModalBody, ModalHeader, Badge } from "reactstrap";
import { SelectPerusahaan } from "../component/Utils";
import { toast } from "react-toastify";
import moment from "moment";
import LoadingTop from "../component/LoadingTop";

class Activity extends Component {
  constructor() {
    super();
    this.state = {
      ValueShowData: 10,
      ValuePage: 0,
      searchName: "",
      typingTimeout: 0,
      modalChangeStatus: false,
      selectedUser: null,
    };
  }

  componentDidMount() {
    this.props.filter.perusahaanFilter = null;
    this.getData();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.filter.perusahaanFilter !== prevProps.filter.perusahaanFilter) {
      this.getDataTable();
    }
  }

  getData = () => {
    const { ValueShowData, ValuePage } = this.state;
    this.props.getData({
      path: `activity?size=${ValueShowData}&page=${ValuePage}`,
      type: "GET_DATA_TABLE_ACTIVITY",
    });
    this.getDataTable(10, 0);
  };

  
  getDataTable = () => {
    let { ValueShowData, ValuePage, searchName } = this.state;
    let searchQs = "";
    if(searchName) {
      searchQs = `&search=user_name:*${searchName}*`;
    }
    if(this.props.filter.perusahaanFilter) {
      if(searchQs === "") searchQs = `&search=user_perusahaan_id:${this.props.filter.perusahaanFilter}`
      else searchQs += `,and,user_perusahaan_id:${this.props.filter.perusahaanFilter}`
      ValuePage = 0;
    }
    this.props.getData({
      path: `activity?size=${ValueShowData}&page=${ValuePage}${searchQs}`,
      type: "GET_DATA_TABLE_ACTIVITY",
    }).then(() => {});
  };

  handlePagginateTable = (ValueShowData, ValuePage) => {
    this.setState(
      {
        ValueShowData: ValueShowData,
        ValuePage: ValuePage - 1,
      },
      () => {
        this.getDataTable();
      }
    );
  };

  toggleModalChangeStatus = () => {
    this.setState((prevState) => ({
      modalChangeStatus: !prevState.modalChangeStatus,
    }));
  };

  parsedDateInd = (cell, row) => {
    return cell
      ? moment.utc(cell).locale("id").tz("Asia/Jakarta").format("DD MMMM YYYY")
      : "-";
  };

  formatterRoles = (cell) => {
    return (
      <p>
        {cell === 1
          ? "Admin"
          : cell === 2
          ? "Gubernur"
          : cell === 3
          ? "Biro"
          : cell === 4
          ? "Komisaris"
          : cell === 5
          ? "Direksi"
          : cell === 6
          ? "Keuangan"
          : cell === 7
          ? "IT"
          : cell === 8
          ? "SDM"
          : ""}
      </p>
    );
  };

  handleSearch = (event) => {
    this.setState(
      {
        searchName: event.target.value,
        ValuePage: 0
      },
      () => {
        if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
        }

        this.setState({
          typingTimeout: setTimeout(() => {
            this.getDataTable();
          }, 100),
        });
      }
    );
  };

  render() {
    const { dataTable } = this.props;
    const { modalChangeStatus } = this.state;

    const columns = [
      {
        dataField: "date",
        text: "Tanggal",
        formatter: this.parsedDateInd,
      },
      {
        dataField: "user.name",
        text: "Nama Akun",
      },
      {
        dataField: "user.role",
        text: "Hak Akses",
        formatter: this.formatterRoles,
      },
      {
        dataField: "user.perusahaan.nama",
        text: "Perusahaan",
      },
      {
        dataField: "description",
        text: "Deskripsi",
        headerStyle: () => ({ width: "30%" }),
      },
    ];

    return (
      <>
        <HeaderComp getData={this.getData} />
        <LoadingTop />
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <div className="row">
                  <div className="col-md-6 order-md-1 order-2">
                    <Input
                      onKeyUp={this.handleSearch}
                      icon
                      iconPosition="left"
                      className="w-100 mb-3"
                      placeholder="Cari Nama Akun"
                    >
                      <input />
                      <Icon name="search" />
                    </Input>
                  </div>
                  <div className="col-md-6 order-md-2 order-1 d-flex align-items-center justify-content-md-end mb-md-0 mb-3">
                    <>
                      <label className="mr-3">Perusahaan</label>
                      <SelectPerusahaan name="perusahaanId" />
                    </>
                  </div>
                </div>
                <TableComp
                  data={dataTable || []}
                  columns={columns}
                  getDataTable={this.handlePagginateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const reduxState = (state) => {
  return {
    dataTable: state.activityReducer.dataTable,
    filter: state.main
  };
};

const reduxDispatch = (dispatch) => ({
  getData: (data) => dispatch(getDataAction(data)),
});

export default connect(reduxState, reduxDispatch)(Activity);
